import * as React from "react";
import { forwardRef } from "react";
const SvgCheckMark = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 21, height: 20, viewBox: "0 0 21 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.92554 12.3029L15.8134 5L17.667 6.85511L7.92554 16L2.66699 10.7744L4.52063 8.93231L7.92554 12.3029Z", fill: "#212121" }));
const ForwardRef = forwardRef(SvgCheckMark);
export default ForwardRef;
